import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaValorParcelaTCC = (): TabelaColuna => ({
  Chave: 'ValorParcelaTCC',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 250 }}>Valor Parcela TCC</div>
})
